import Snackbar from "@mui/material/Snackbar";

const Notification = (props) => {
    const { open, onClose, message, autoHideDuration } = props;

    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            message={<span id="message-id">{message}</span>}
            slotProps={{
                content: {
                    "aria-describedby": "message-id",
                },
            }}
        />
    );
};

export default Notification;
